export const packagesData = {
  core_access: {
    logoUrl: 'eclipse/package-picker/core_access_header_logo.svg',
    logoWidth: 71,
    title: 'packagePicker.coreOffer.core_access.title',
    altText: '',
  },
  core_plus: {
    logoUrl: 'eclipse/package-picker/core_plus_header_logo.svg',
    logoWidth: 86,
    title: 'packagePicker.coreOffer.core_plus.title',
    altText: '',
  },
  core_pro: {
    logoUrl: 'eclipse/package-picker/core_pro_header_logo.svg',
    logoWidth: 59,
    title: 'packagePicker.coreOffer.core_pro.title',
    altText: '',
  },
  core_pro_plus: {
    logoUrl: 'eclipse/package-picker/core_pro_plus_header_logo.svg',
    logoWidth: 75,
    title: 'packagePicker.coreOffer.core_pro_plus.title',
    altText: '',
  },
  core_max: {
    logoUrl: 'eclipse/package-picker/core_pro_plus_header_logo.svg',
    logoWidth: 75,
    title: 'packagePicker.coreOffer.core_max.title',
    altText: '',
  },
};
